import { takeEvery, call, put } from 'redux-saga/effects'
import makeAPIRequest from 'store/entities/api/sagas'
import * as REQUESTS from 'app/constants/requests'
import { FAVORITE_ACTIVITIES } from '../actionTypes'
import { FAVORITE_ACTIVITIES_DELETE_PATH } from 'app/constants/api/favoriteActivity'
import { favoriteActivities } from '../actions'
import { showSuccess, showError } from 'store/entities/toastr/utils'
import { FAVORITE_ACTIVITY_REMOVED } from 'app/constants/toastrMessages'

export default function* favoriteActivitiesDeleteSaga() {
  yield takeEvery(FAVORITE_ACTIVITIES.DELETE.REQUEST, handleFavoriteActivitiesDelete)
}

export function* handleFavoriteActivitiesDelete({ payload }) {
  const { activityId, isYesterday } = payload && payload.data
  try {
    const response = yield call(makeAPIRequest, FAVORITE_ACTIVITIES_DELETE_PATH(activityId), {
      method: REQUESTS.DELETE,
    })
    const { data } = response.data
    yield put(favoriteActivities.delete.success({ data, meta: { id: activityId, previous: isYesterday } }))
    showSuccess({ content: FAVORITE_ACTIVITY_REMOVED })
  } catch (badResponse) {
    console.log(badResponse)
    yield put(favoriteActivities.delete.fail(badResponse))
    showError()
  }
}
